<template>
  <div class="loading-spinner">
    <div class="spinner-wrapper">
      <v-progress-circular
        indeterminate
        color="primary"
        size="50"
      />
      <div class="loading-text mt-2">
        Loading...
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingSpinner"
}
</script>

<style scoped>
.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 9999;
}

.spinner-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loading-text {
  color: #0078D7;
  font-weight: 500;
  margin-top: 8px;
}
</style>
